/** Shared helpers for recomputing table total rows from filtered data rows. */

export function hasActiveTextFilters(textFilters = {}) {
  return Object.values(textFilters).some((v) => v != null && String(v).trim() !== "");
}

export function hasActiveNumFilters(numFilters = {}) {
  return Object.values(numFilters).some(
    (f) => f && f.value !== "" && f.value !== undefined && f.value !== null,
  );
}

export function hasActiveColFilters(colFilters = {}) {
  return Object.entries(colFilters).some(([, f]) => {
    if (!f) return false;
    const v = f.value;
    if (v !== "" && v !== undefined && v !== null) return true;
    return typeof v === "string" && v.trim() !== "";
  });
}

export function hasAnyTableFilters(...checks) {
  return checks.some(Boolean);
}

export function sumNullableNumbers(values) {
  let sum = 0;
  let any = false;
  for (const v of values) {
    if (v != null && v !== "") {
      sum += Number(v);
      any = true;
    }
  }
  return any ? sum : null;
}

export function sumRows(rows, getter) {
  return sumNullableNumbers(rows.map(getter));
}

/** Use API total when no filters; otherwise aggregate from filtered rows. */
export function resolveFilteredTotal(apiTotal, filteredRows, hasFilters, aggregateFn) {
  if (!hasFilters || !filteredRows?.length) return apiTotal;
  const computed = aggregateFn(filteredRows);
  return computed ?? apiTotal;
}

/** Sum hours/dollars per month for Monthly TM Hours reports. */
export function aggregateMonthlyTmGrandTotal(rows, monthKeys) {
  const out = {};
  for (const mk of monthKeys) {
    out[mk] = {
      hours: sumRows(rows, (r) => r.months?.[mk]?.hours) ?? 0,
      dollars: sumRows(rows, (r) => r.months?.[mk]?.dollars) ?? 0,
    };
  }
  return out;
}
